"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulerTabUtils = void 0;
var paragraph_1 = require("../../../../../core/model/paragraph/paragraph");
var template_manager_1 = require("../template-manager");
var RulerTabUtils = (function () {
    function RulerTabUtils() {
    }
    RulerTabUtils.getTabTitlePropertyName = function (align) {
        var alignString = "";
        switch (align) {
            case paragraph_1.TabAlign.Left:
                alignString = "Left";
                break;
            case paragraph_1.TabAlign.Right:
                alignString = "Right";
                break;
            case paragraph_1.TabAlign.Center:
                alignString = "Center";
                break;
            case paragraph_1.TabAlign.Decimal:
                alignString = "Decimal";
                break;
        }
        return "tab" + alignString;
    };
    RulerTabUtils.getSpriteClassName = function (tabAlign, settings) {
        switch (tabAlign) {
            case paragraph_1.TabAlign.Left:
                return settings.styles.tabImages.left.spriteCssClass;
            case paragraph_1.TabAlign.Right:
                return settings.styles.tabImages.right.spriteCssClass;
            case paragraph_1.TabAlign.Center:
                return settings.styles.tabImages.center.spriteCssClass;
            case paragraph_1.TabAlign.Decimal:
                return settings.styles.tabImages.decimal.spriteCssClass;
        }
        return "";
    };
    RulerTabUtils.getTemplate = function (tabAlign) {
        switch (tabAlign) {
            case paragraph_1.TabAlign.Left:
                return template_manager_1.RulerTemplateManager.getLeftTabElementTemplate();
            case paragraph_1.TabAlign.Right:
                return template_manager_1.RulerTemplateManager.getRightTabElementTemplate();
            case paragraph_1.TabAlign.Center:
                return template_manager_1.RulerTemplateManager.getCenterTabElementTemplate();
            case paragraph_1.TabAlign.Decimal:
                return template_manager_1.RulerTemplateManager.getDecimalTabElementTemplate();
        }
    };
    return RulerTabUtils;
}());
exports.RulerTabUtils = RulerTabUtils;
